import React from 'react';

import logof from '../assests/sklogo_.png'

const currentYear = new Date().getFullYear();

const FooterWithSocialLinks = () => {
  return (
    <footer className="bg-[#EDE8E2] text-gray-700 py-6 px-6 md:px-8">
      {/* Main Content */}
      <div className="max-w-7xl mx-auto grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-8">
        {/* Logo */}
        <div className="col-span-2 gap-5 mb-1 sm:col-span-1 flex flex-col items-center sm:items-start text-center sm:text-left">
          <img src={logof} alt="Logo" style={{height:'1rem'}} />
          <p className="text-sm">Timeless Moments Photography</p>
        </div>

        {/* Services */}
        <div>
          <h3 className="font-semibold text-lg mb-2">Our Services</h3>
          <ul className="text-sm space-y-1">
            <li><a href="/portfolio">Wedding Photography</a></li>
            <li><a href="/portfolio">Engagement Shoots</a></li>
            <li><a href="/portfolio">Haldi Ceremony</a></li>
            <li><a href="/portfolio">Pre-Wedding Sessions</a></li>
          </ul>
        </div>

        {/* Navigation */}
        <div>
          <h3 className="font-semibold text-lg mb-2">Quick Links</h3>
          <ul className="text-sm space-y-1">
            <li><a href="/" className="hover:underline">Home</a></li>
            <li><a href="/services" className="hover:underline">Services</a></li>
            <li><a href="/portfolio" className="hover:underline">Portfolio</a></li>
            <li><a href="/contact" className="hover:underline">Contact</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="font-semibold text-lg mb-2">Contact Us</h3>
          <p className="text-sm">Datta Chowk,Opp.Rajan Toylor</p>
          <p className="text-sm">Solapur, Maharashtra 413001</p>
          <p className="text-sm">Phone:+91 9130703656</p>
          <p className="text-sm">Email: chauhansandip015@gmail.com</p>
        </div>
      </div>

      {/* Social Media and Copyright */}
      <div className="mt-6 pt-6 border-t border-gray-300">
        <div className="flex flex-col sm:flex-row justify-between items-center">
          <div className="flex space-x-4 mb-4 sm:mb-0">
            {/* Replace these divs with actual social media icons */}
            <div style={{display:'flex',alignItems:'center'}} className="w-10 h-8 rounded-full"><a href="tel:9130703656"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.275 15.4875C10.075 19.025 12.975 21.9125 16.5125 23.725L19.2625 20.975C19.6 20.6375 20.1 20.525 20.5375 20.675C21.9375 21.1375 23.45 21.3875 25 21.3875C25.6875 21.3875 26.25 21.95 26.25 22.6375V27C26.25 27.6875 25.6875 28.25 25 28.25C13.2625 28.25 3.75 18.7375 3.75 7C3.75 6.3125 4.3125 5.75 5 5.75H9.375C10.0625 5.75 10.625 6.3125 10.625 7C10.625 8.5625 10.875 10.0625 11.3375 11.4625C11.475 11.9 11.375 12.3875 11.025 12.7375L8.275 15.4875Z" fill="black"/>
</svg></a>
</div>
            <div style={{display:'flex',alignItems:'center'}} className="w-10 h-8 rounded-full"><a href="https://api.whatsapp.com/send?phone=9130703656&text=Hello"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.8125 6.13757C22.6663 4.9802 21.3013 4.06253 19.7969 3.43802C18.2925 2.81352 16.6789 2.49467 15.05 2.50007C8.225 2.50007 2.6625 8.06257 2.6625 14.8876C2.6625 17.0751 3.2375 19.2001 4.3125 21.0751L2.5625 27.5001L9.125 25.7751C10.9375 26.7626 12.975 27.2876 15.05 27.2876C21.875 27.2876 27.4375 21.7251 27.4375 14.9001C27.4375 11.5876 26.15 8.47507 23.8125 6.13757ZM15.05 25.1876C13.2 25.1876 11.3875 24.6876 9.8 23.7501L9.425 23.5251L5.525 24.5501L6.5625 20.7501L6.3125 20.3626C5.28443 18.7214 4.73866 16.8242 4.7375 14.8876C4.7375 9.21257 9.3625 4.58757 15.0375 4.58757C17.7875 4.58757 20.375 5.66257 22.3125 7.61257C23.272 8.5674 24.0324 9.70325 24.5495 10.9542C25.0667 12.2052 25.3302 13.5464 25.325 14.9001C25.35 20.5751 20.725 25.1876 15.05 25.1876ZM20.7 17.4876C20.3875 17.3376 18.8625 16.5876 18.5875 16.4751C18.3 16.3751 18.1 16.3251 17.8875 16.6251C17.675 16.9376 17.0875 17.6376 16.9125 17.8376C16.7375 18.0501 16.55 18.0751 16.2375 17.9126C15.925 17.7626 14.925 17.4251 13.75 16.3751C12.825 15.5501 12.2125 14.5376 12.025 14.2251C11.85 13.9126 12 13.7501 12.1625 13.5876C12.3 13.4501 12.475 13.2251 12.625 13.0501C12.775 12.8751 12.8375 12.7376 12.9375 12.5376C13.0375 12.3251 12.9875 12.1501 12.9125 12.0001C12.8375 11.8501 12.2125 10.3251 11.9625 9.70007C11.7125 9.10007 11.45 9.17507 11.2625 9.16257H10.6625C10.45 9.16257 10.125 9.23757 9.8375 9.55007C9.5625 9.86257 8.7625 10.6126 8.7625 12.1376C8.7625 13.6626 9.875 15.1376 10.025 15.3376C10.175 15.5501 12.2125 18.6751 15.3125 20.0126C16.05 20.3376 16.625 20.5251 17.075 20.6626C17.8125 20.9001 18.4875 20.8626 19.025 20.7876C19.625 20.7001 20.8625 20.0376 21.1125 19.3126C21.375 18.5876 21.375 17.9751 21.2875 17.8376C21.2 17.7001 21.0125 17.6376 20.7 17.4876Z" fill="black"/>
</svg></a>
</div>
            <div style={{display:'flex',alignItems:'center'}} className="w-10 h-8  rounded-full"><a href="https://www.instagram.com/kuldeepc.7"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.75 4.375H11.25C7.45304 4.375 4.375 7.45304 4.375 11.25V18.75C4.375 22.547 7.45304 25.625 11.25 25.625H18.75C22.547 25.625 25.625 22.547 25.625 18.75V11.25C25.625 7.45304 22.547 4.375 18.75 4.375Z" stroke="black" stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.0002 19.5077C17.4896 19.5077 19.5077 17.4896 19.5077 15.0002C19.5077 12.5108 17.4896 10.4927 15.0002 10.4927C12.5108 10.4927 10.4927 12.5108 10.4927 15.0002C10.4927 17.4896 12.5108 19.5077 15.0002 19.5077Z" stroke="black" stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21.1176 10.1702C21.8286 10.1702 22.4051 9.59378 22.4051 8.88271C22.4051 8.17165 21.8286 7.59521 21.1176 7.59521C20.4065 7.59521 19.8301 8.17165 19.8301 8.88271C19.8301 9.59378 20.4065 10.1702 21.1176 10.1702Z" fill="black"/>
</svg>
</a>
</div>
            <div style={{display:'flex',alignItems:'center'}} className="w-10 h-8 rounded-full">
            <a href="mailto:chauhansandip015@gmail.com?subject=Important!&body=Hi."><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.8125 5.3125H7.1875C5.11643 5.3125 3.4375 6.99143 3.4375 9.0625V20.9375C3.4375 23.0086 5.11643 24.6875 7.1875 24.6875H22.8125C24.8836 24.6875 26.5625 23.0086 26.5625 20.9375V9.0625C26.5625 6.99143 24.8836 5.3125 22.8125 5.3125Z" stroke="black" stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.4375 10L13.9562 14.8325C14.2836 14.9829 14.6397 15.0608 15 15.0608C15.3603 15.0608 15.7164 14.9829 16.0438 14.8325L26.5625 10" stroke="black" stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</a>
            </div>
          </div>
          <p className="text-sm text-center sm:text-right">
            © {currentYear} Sk Photo Film. All rights reserved.
          </p>
        </div>
      </div>

      {/* Handcrafted by */}
      <div className="mt-4 text-sm text-center sm:text-right">
        Handcrafted by <a href="https://jtwebss.com" target="_blank" rel="noopener noreferrer" className="font-semibold hover:underline">JTWebs</a>
      </div>
    </footer>
  );
};



export default FooterWithSocialLinks;